module.exports = __webpack_public_path__ + "img/07.c7bca5aa.jpg";